import {
  getCurrentPosition,
  searchCity,
  getCityInfo,
  getAddressInfo
} from '@/utils/aMap'
import { movieCityListApi } from '@/api/movie'

const state = {
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: '',
    city_id: ''
  }
}

// 默认定位信息
const DEFAULT_LAT = 23.12463
const DEFAULT_LNG = 113.36199
const DEFAULT_CITY = '广州市'
const DEFAULT_PROVINCE = '广东省'

// 设置定位信息
const setLatLng = (state, lng, lat) => {
  state.locationInfo.lng = lng
  state.locationInfo.lat = lat
}

// 设置城市信息
const setCityInfo = (state, city, province) => {
  state.locationInfo.city = city || DEFAULT_CITY
  state.locationInfo.province = province || DEFAULT_PROVINCE
}

const resolveCityByType = async (state, result) => {
  const { location_type, position } = result

  if (location_type === 'ipcity') {
    const [lng, lat] = position
    setLatLng(state, lng, lat)

    setCityInfo(state, result.city, result.province)
    return {
      status: true,
      message: '通过IP定位获取城市信息成功'
    }
  }

  if (location_type === 'html5') {
    const { lng, lat } = position
    setLatLng(state, lng, lat)
    try {
      const {
        status: adStatue,
        result: adResult
      } = await getAddressInfo(
        result.position?.lng || '',
        result.position?.lat || ''
      )

      if (adStatue === 'complete') {
        const {
          city,
          province
        } = adResult.regeocode.addressComponent
        setCityInfo(state, city || '', province || '')
        return {
          status: true,
          message: 'HTML5定位获取城市信息成功'
        }
      } else {
        setCityInfo(state, result.city, result.province)
        return {
          status: true,
          message: '获取定位成功，地址解析失败'
        }
        console.warn('获取地址信息失败', adResult)
      }
    } catch (err) {
      console.error('获取地址信息失败', err)
    }
  }
}

// 获取定位
const getLocation = async ({ state }) => {
  // 获取定位信息 浏览器
  try {
    const { status, result } = await getCurrentPosition()
    if (status !== 'complete') {
      // 如果定位失败，ip定位获取城市信息
      const {
        status: cityStatus,
        result: cityResult
      } = await getCityInfo()
      if (cityStatus === 'complete') {
        setCityInfo(
          state,
          cityResult.city || '',
          cityResult.province || ''
        )
        conosle.log()
        setLatLng(
          state,
          cityResult.position?.[0] || '',
          cityResult.position?.[1] || ''
        )
        return Promise.resolve({
          status: true,
          message: '定位获取城市信息成功'
        })
        // searchCity()
      }
    }

    const cityResult = await resolveCityByType(
      state,
      result
    )
    if (cityResult?.status) {
      return 
    }
     Promise.resolve({
      status: false,
      message: '获取定位失败，使用默认位置'
    })
    // 定位失败，使用默认定位
    setLatLng(state, DEFAULT_LNG, DEFAULT_LAT)
    setCityInfo(state, DEFAULT_CITY, DEFAULT_PROVINCE)
  } catch (err) {
    console.warn('定位错误', err)

    // 定位失败，使用默认定位
    setLatLng(state, DEFAULT_LNG, DEFAULT_LAT)
    setCityInfo(state, DEFAULT_CITY, DEFAULT_PROVINCE)
  }
}

// 设置城市信息
const setCity = async ({ state }, cityName, type) => {
  try {
    state.locationInfo.city = cityName || DEFAULT_CITY
    return { status: true, message: '设置城市信息成功' }
  } catch (err) {
    console.warn('设置城市信息错误', err)
    return { status: false, message: '设置城市信息失败' }
  }
}

const fetchAndSetMovieCityId = async (
  { state },
  cityName
) => {
  try {
    state.locationInfo.city_id = ''

    if (!cityName) {
      return {
        status: false,
        cityInfo: {},
        message: '城市为空'
      }
    }

    const City = cityName.replace(/市$/, '')
    const response = await movieCityListApi({
      keyword: City
    })

    const data = response.data?.data
    const cityInfo = data?.cityList?.[0] || {}
    state.locationInfo.city_id =
      cityInfo.id || cityInfo.city_id || ''

    if (data?.status && state.locationInfo.city_id) {
      return {
        status: true,
        cityInfo,
        message: '获取电影城市ID成功'
      }
    }

    return {
      status: false,
      cityInfo: {},
      message: '当前城市暂未开通电影服务, 请选择其它城市'
    }
  } catch (err) {
    console.error('获取电影城市ID失败', err)
    state.locationInfo.city_id = ''
    return {
      status: false,
      cityInfo: {},
      message: '获取电影城市ID失败'
    }
  }
}

export default {
  namespaced: true,
  state,
  actions: { getLocation, setCity, fetchAndSetMovieCityId }
}
